import { useAppSelector } from '@application/store/useStore';
import { centeredRowStack } from '@ui/style/style';
import { getContrastText } from '@ui/theme/palette';
const useTabWithBadgeStyles = (badgeColor, badgeTextColor) => {
    const companyTheme = useAppSelector((state) => state.companyTheme.currentTheme);
    return {
        badgeContainer: {
            ...centeredRowStack,
            gap: 1
        },
        badge: {
            ...centeredRowStack,
            justifyContent: 'center',
            backgroundColor: (theme) => companyTheme?.primaryColor || theme.palette.primary.main,
            color: (theme) => companyTheme?.primaryColor
                ? getContrastText(companyTheme.primaryColor)
                : theme.palette.primary.contrastText,
            borderRadius: '500px',
            minWidth: '26px',
            height: '20px',
            px: '6px',
            boxSizing: 'border-box',
            whiteSpace: 'nowrap',
            gap: 1
        },
        noOfTasks: {
            fontWeight: 700
        },
        tabText: {}
    };
};
export default useTabWithBadgeStyles;
